import classnames from 'classnames';
import React from 'react';

/**
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/label
 *
 * @param props BaseLabelProps
 * @returns FunctionComponent<BaseLabelProps>
 */ const BaseLabel = (props)=>{
    const { children, className, htmlFor, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement("label", {
        ...otherProps,
        className: classnames({
            'bf-label': true,
            [`${className}`]: !!className
        }),
        htmlFor: htmlFor
    }, children);
};

export { BaseLabel };
//# sourceMappingURL=base-label.js.map
